module.exports = "<div class=\"footer\">\r\n  <a class=\"tab\" routerLink=\"/terms-of-use\">Terms of Use</a>\r\n  <a class=\"tab\" routerLink=\"/privacy-policy\">Privacy Policy</a>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/app/shared/components/footer/footer.component.html
// module id = ../../../../../src/app/shared/components/footer/footer.component.html
// module chunks = main